module.exports = __webpack_public_path__ + "static/media/min-digital.f2bc10d7.png";